import { Identify } from '@amplitude/unified';

export interface IdentifyInput {
  userId: string;
  email: string;
  organizationId: string;
  organizationName: string;
}

export function buildIdentify(input: IdentifyInput): Identify {
  const identify = new Identify();
  identify.set('email', input.email);
  identify.set('organization_id', input.organizationId);
  identify.set('organization_name', input.organizationName);
  identify.set('is_internal_user', input.email.endsWith('@monks.com'));
  identify.set('environment', import.meta.env.SENTRY_ENVIRONMENT || 'unknown');
  return identify;
}
